import { render, staticRenderFns } from "./CreateUpdateUser.vue?vue&type=template&id=1a074463&scoped=true&"
import script from "./CreateUpdateUser.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateUser.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpdateUser.vue?vue&type=style&index=0&id=1a074463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a074463",
  null
  
)

export default component.exports